import { createReducer, on } from '@ngrx/store';
import { setActiveMenuCode} from '../actions/global.action';

export interface GlobalState {
    activeMenuCode: string;
}

export const initialState: GlobalState = {
    activeMenuCode: '',
};

export const globalReducer = createReducer(
    initialState,
    on(setActiveMenuCode, (state, { activeMenuCode }) => ({ ...state, activeMenuCode })),
);